import React from "react";

const UserDetailsPanel = ({ user }) => {
  if (!user) return null;

  const formatDate = (value) =>
    value ? new Date(value).toLocaleString() : "—";

  return (
    <div className="order-details-panel">
      <div className="order-details-block">
        <h4>Account details</h4>
        <dl className="order-details-dl">
          <div className="order-details-row">
            <dt>User ID</dt>
            <dd>{user.id}</dd>
          </div>
          <div className="order-details-row">
            <dt>Full name</dt>
            <dd>{user.name}</dd>
          </div>
          <div className="order-details-row">
            <dt>Email</dt>
            <dd>{user.email}</dd>
          </div>
          <div className="order-details-row">
            <dt>Phone</dt>
            <dd>{user.phone || "—"}</dd>
          </div>
          <div className="order-details-row">
            <dt>Role</dt>
            <dd>{user.role}</dd>
          </div>
          <div className="order-details-row">
            <dt>Status</dt>
            <dd>{user.isActive !== false ? "Active" : "Inactive"}</dd>
          </div>
          <div className="order-details-row">
            <dt>Joined</dt>
            <dd>{formatDate(user.createdAt)}</dd>
          </div>
          <div className="order-details-row">
            <dt>Last login</dt>
            <dd>{formatDate(user.lastLoginAt)}</dd>
          </div>
          <div className="order-details-row">
            <dt>Last updated</dt>
            <dd>{formatDate(user.updatedAt)}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default UserDetailsPanel;
